angular
  .module('capability-ng-scheduler')
  .service('suggestionsService', function suggestionsService(SuggestionsBuilder) {
    'use strict';

    this.areAllCoursesAvailable = function areAllCoursesAvailable(courses) {
      return _.every(courses, '_no_sections_available', false);
    };

    this.areUnscheduledCoursesAvailable = function areUnscheduledCoursesAvailable(sections) {
      var unscheduledCourses = this.getUnscheduledCourses(sections);

      return this.areAllCoursesAvailable(unscheduledCourses);
    };

    this.getUnscheduledCourses = function getUnscheduledCourses(sections) {
      // Unscheduled sections have empty statuses and are not selected...
      var unscheduledSections = _.filter(sections, function (section) {
        return _.isEmpty(section._section_status.status) && !section._section_status.is_selected;
      });

      return _.map(unscheduledSections, '_course');
    };
  });



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/course_scheduler/modals/suggestions/services/suggestions_service.js